import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../../../services/order.service';
import { ApiResult } from '../../../../../shared/models/api-result.model';
import {
  ContractStatus,
  ResponseSignContract,
} from '../../../../models/contract.model';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  imports: [ToastModule, ProgressSpinnerModule],
  template: `
    <p-toast />
    <div
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
    >
      <p-progress-spinner ariaLabel="loading" />
    </div>
  `,
})
export class DocuSignValidateComponent {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private orderService = inject(OrderService);

  ngOnInit(): void {
    const contractId = this.activatedRoute.snapshot.paramMap.get('contractId');
    if (!contractId) {
      this.router.navigate(['/home']);
      return;
    }

    this.orderService.checkStatusContractAfterSignature(contractId).subscribe({
      next: (response: ApiResult) => {
        console.log(response);
        const data = response.data as ResponseSignContract;
        if (data.status === ContractStatus.Signed && data.orderId) {
          this.router.navigate(['/internal/checkout', data.orderId]);
          return;
        }
        this.router.navigate(['/home']);
      },
      error: () => {
        this.router.navigate(['/home']);
      },
    });
  }
}